
import { usePasswordResetHandler } from './auth/usePasswordResetHandler';
import { useSignupHandler } from './auth/useSignupHandler';
import { useLoginHandler } from './auth/useLoginHandler';
import { useSocialAuthHandler } from './auth/useSocialAuthHandler';

// This hook centralizes all auth-related handlers
export const useAuthHandler = () => {
  // Get other auth handler hooks
  const { loading: signupLoading, handleSignup } = useSignupHandler();
  const { loading: loginLoading, handleLogin } = useLoginHandler();
  const { 
    loading: passwordResetLoading, 
    handlePasswordReset,
    handleUpdatePassword
  } = usePasswordResetHandler();
  const { 
    googleLoading, 
    handleGoogleLogin
  } = useSocialAuthHandler();
  
  // Combined loading state
  const loading = signupLoading || loginLoading || passwordResetLoading || googleLoading;
  
  return {
    loading,
    handleSignup,
    handleLogin,
    handlePasswordReset,
    handleUpdatePassword,
    handleGoogleLogin
  };
};
